# Constructs the fine print for the Fine Print view based on the deal Type
#
SupportUtilsHelper = require('../helpers/utils')

class SupportFinePrintPresenterPresentation
  present: (order) ->
    text = switch order.DEAL_TYPE
      when 'GETAWAYS_MARKET_RATE' then @marketRateFinePrintConstructor order
      else @v1FinePrintConstructor order

  v1FinePrintConstructor: (order) ->
    return "" unless order?
    replaceNewLineWithBreak order.deal?.finePrint

  marketRateFinePrintConstructor: (order) ->
    reservationSource = SupportUtilsHelper.getReservationSource(order)
    return "" unless reservationSource?
    cancellationPolicies = _.reduce reservationSource.cancellationPolicies, ( (memo, policy) -> "#{memo}#{policy.descriptionHtml} <br />" ), ""
    "#{reservationSource.crsPolicyHtml} <br />Cancellation Policies <br /><br /> #{cancellationPolicies}"

module.exports = SupportFinePrintPresenterPresentation
